import React, { useEffect, useState } from "react";
import Button from "../common/Button/Button";
import api from "../../services/api";
import StockPicker from "../common/StockPicker";
import styles from "./Notifications.module.css";

const AddNotifications = ({ notificationId, onSubmitted, onCancel }) => {
    const id = notificationId;
    const [formData, setFormData] = useState({
        title: "",
        message: "",
        queryType: null,
        notificationtype: null,
        trigger_time: "",
        trigger_date: "",
        newsId: null,
        stockToken: null,
        stockSymbol: null,
        stockIsin: null
    });
    const [notificationsType, setNotificationsType] = useState([])
    const [queryType, setQueryType] = useState([])
    const [publishedArticles, setPublishedArticles] = useState([])


    const fetchStocks = async (inputValue) => {
        try {
            const response = await api.get(`/internaltoken/search?q=${inputValue}`);
            if (response && response.status && Array.isArray(response.data)) {
                return response.data.map(stock => ({
                    value: stock.token,
                    label: stock.symbol,
                    symbol: stock.symbol,
                    name: stock.name,
                    exchange: stock.exch_seg || "NSE",
                    isin: stock.isin || null
                }));
            }
            return [];
        } catch (error) {
            console.error("Error fetching stocks:", error);
            return [];
        }
    };

    const fetchDropdownMenu = async () => {
        try {
            const [notificationType, queryType] = await Promise.all([
                api.get('/notificationtype'),
                api.get('/notification-query')
            ])

            setNotificationsType(notificationType.data)

            setQueryType(queryType.data)

        } catch (error) {
            console.error("Error fetching options")
        }
    }

    useEffect(() => {
        fetchDropdownMenu()
    }, [])

    // Fetch published articles when notification type is News (4)
    // Clear stock fields when notification type is not Stock Update (5)
    useEffect(() => {
        if (String(formData.notificationtype) === "4") {
            api.get('/newsfeed/published')
                .then((res) => {
                    setPublishedArticles(res.data || []);
                })
                .catch((err) => console.error("Error fetching articles:", err));
        } else {
            setPublishedArticles([]);
            setFormData((prev) => ({ ...prev, newsId: null }));
        }

        if (String(formData.notificationtype) !== "5") {
            setFormData((prev) => ({ ...prev, stockToken: null, stockSymbol: null, stockIsin: null }));
        }
    }, [formData.notificationtype])

    useEffect(() => {
        if (id) {
            api.get(`/notifications/${id}`)
                .then((res) => {

                    const notification = res.result?.[0];
                    if (notification) {
                        setFormData({
                            title: notification.title || "",
                            message: notification.message || "",
                            queryType: notification.query || "",
                            notificationtype: notification.notificationtypeid,
                            trigger_time: notification.trigger_time || "",
                            // trigger_date: notification.trigger_date || "",
                           trigger_date: new Date(notification.trigger_date).toLocaleDateString('en-CA') || "",
                           newsId: notification.news_id || null,
                           stockToken: notification.stock_token || null,
                           stockSymbol: notification.stock_symbol || null,
                           stockIsin: notification.stock_isin || null
                        });
                    }
                })
                .catch((err) => console.error("Error loading notification:", err));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            title: formData.title,
            message: formData.message,
            query: formData.queryType,
            notificationtypeid: formData.notificationtype,
            trigger_time: formData.trigger_time,
            trigger_date: formData.trigger_date,
            ...(formData.newsId ? { newsId: formData.newsId } : {}),
            ...(formData.stockToken ? { stockToken: formData.stockToken } : {}),
            ...(formData.stockSymbol ? { stockSymbol: formData.stockSymbol } : {}),
            ...(formData.stockIsin ? { stockIsin: formData.stockIsin } : {})
        }


        const apiCall = id
            ? api.put(`/notifications/${id}`, payload)   // Edit mode
            : api.post(`/notifications`, payload);       // Add mode

        apiCall
            .then(() => { if (onSubmitted) onSubmitted(); })
            .catch((error) => console.error("Error:", error));
    };


    return (
        <div className="moduleFormContainer">
            <div className="moduleFormCard">



                <form onSubmit={handleSubmit} className="moduleForm">

                    <div className="form-grid">
                        <div className="form-group">
                            <label>Title</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                                maxLength={60}
                            />
                        </div>

                        <div className="form-group">
                            <label>Notification Type</label>
                            <select
                                name="notificationtype"
                                value={formData.notificationtype || ""}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Select</option>
                                {notificationsType.map((module) => (
                                    <option key={module.notificationtypeid} value={module.notificationtypeid}>
                                        {module.notificationtypename}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Query Type</label>
                            <select
                                name="queryType"
                                value={formData.queryType || ""}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Query Type</option>
                                {queryType.map((module) => (
                                    <option key={module.id} value={module.id}>
                                        {module.query_title}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div className="form-group">
                            <label>Trigger Date</label>
                            <input
                                type="date"
                                name="trigger_date"
                                value={formData.trigger_date}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Trigger Time</label>
                            <input
                                type="time"
                                name="trigger_time"
                                value={formData.trigger_time}
                                onChange={handleChange}
                            />
                        </div>

                        {String(formData.notificationtype) === "4" && publishedArticles.length > 0 && (
                            <div className="form-group">
                                <label>Link to Article (optional)</label>
                                <select
                                    name="newsId"
                                    value={formData.newsId || ""}
                                    onChange={handleChange}
                                    className={styles.w100}
                                >
                                    <option value="">No specific article</option>
                                    {publishedArticles.map((article) => (
                                        <option key={article.news_id} value={article.news_id}>
                                            {article.title?.length > 138 ? article.title.substring(0, 138) + "..." : article.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {String(formData.notificationtype) === "5" && (
                            <div className="form-group">
                                <StockPicker
                                    value={
                                        formData.stockToken
                                            ? {
                                                  value: formData.stockToken,
                                                  label: formData.stockSymbol,
                                                  symbol: formData.stockSymbol,
                                                  name: formData.stockSymbol,
                                                  isin: formData.stockIsin,
                                              }
                                            : null
                                    }
                                    onChange={(selected) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            stockToken: selected ? selected.value : null,
                                            stockSymbol: selected ? selected.symbol : null,
                                            stockIsin: selected ? selected.isin : null,
                                        }));
                                    }}
                                    fetchStocks={fetchStocks}
                                    placeholder="Search stock..."
                                />
                            </div>
                        )}


                        <div className={`form-group ${styles.gridColFull}`}>
                            <label>Message</label>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                className={`${styles.textarea} ${styles.textareaMinH5}`}
                                rows={10}
                                maxLength={200}
                            />
                        </div>

                    </div>

                    <div className="formActions">
                        <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
                        <button type="button" className="backButton" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default AddNotifications;